/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterChildDto } from '../../models/center-child-dto';

export interface AdminCenterChildControllerFindAll$Params {

/**
 * 센터 ID
 */
  centerId: string;

/**
 * 바우처
 */
  vouchers?: Array<string>;

/**
 * 치료 유형
 */
  ticketTypes?: Array<string>;
}

export function adminCenterChildControllerFindAll(http: HttpClient, rootUrl: string, params: AdminCenterChildControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterChildDto>>> {
  const rb = new RequestBuilder(rootUrl, adminCenterChildControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('centerId', params.centerId, {});
    rb.query('vouchers', params.vouchers, {});
    rb.query('ticketTypes', params.ticketTypes, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CenterChildDto>>;
    })
  );
}

adminCenterChildControllerFindAll.PATH = '/api/center-child/admin/all';
